import { Dropdown } from 'flowbite-react';
import React, { useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { useClaimHistoryQuery } from "../../hooks/useTravelClaimQuery";
import { ClaimHistory } from "../../types/travelClaims";
import { formatDateTime } from "../../helpers/dates";
import { LoadingMore } from "../Loading";
import { getUserFioShort } from "../../helpers/users";


interface HistoryProps {
    record: ClaimHistory
}

export const HistoryItem = ({ record }: HistoryProps) => {
    const navigate = useNavigate();
    return (
        <div
            className="
            cursor-pointer
            flex flex-col w-full
            items-start
            gap-3.5 px-5 py-0
            relative flex-[0_0_auto] bg-bgcard
            ">
            <div className="flex flex-col w-full items-start gap-5 relative flex-[0_0_auto]">
                <div className="flex flex-col w-full items-start gap-4 relative flex-[0_0_auto]">
                    {/*DATETIME AND MENU*/}
                    <div className="flex w-full items-start gap-[5px] relative flex-[0_0_auto]">
                        <div className="inline-flex flex-row w-full justify-between items-center relative">
                            {/*DATETIME*/}
                            <div className="inline-flex items-start gap-[5px] relative flex-[0_0_auto]">
                                <div
                                    className="relative w-fit [font-family:'Acrom-Medium',Helvetica] font-medium text-[#949494] text-base text-right tracking-[0] leading-5 whitespace-nowrap">
                                    {record.history_date ? formatDateTime(record.history_date, false) : '--:--'}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*DETAILS*/}
                    <div className="flex flex-col w-full items-start gap-2 relative flex-[0_0_auto]">
                        {/*TITLE*/}
                        <div className="inline-flex items-start relative flex-[0_0_auto]">
                            {/*TITLE TEXT*/}
                            <p className="relative w-full mt-[-1.00px] font-manager-acrom-h3-20-medium-acrom font-[number:var(--manager-acrom-h3-20-medium-acrom-font-weight)] text-black text-[length:var(--manager-acrom-h3-20-medium-acrom-font-size)] tracking-[var(--manager-acrom-h3-20-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-h3-20-medium-acrom-line-height)] [font-style:var(--manager-acrom-h3-20-medium-acrom-font-style)]">
                                {getUserFioShort(record.history_user)}
                            </p>
                        </div>
                        {/*MESSAGE*/}
                        <p className="relative w-full font-manager-acrom-ph1-16-medium-acrom font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)] text-[#949494] text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)] tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)] leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)] [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]">
                            {record.history_change_reason}
                        </p>
                    </div>
                </div>
            </div>
            <div className="relative w-full h-px bg-line" />
        </div>
    );
}

export const HistoryDropdown = () => {
    const queryClient = useQueryClient();
    const { pk } = useParams();
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useClaimHistoryQuery(pk || '')


    // Ref на выпадающий список
    const dropdownRef = useRef(null);

    const handleScroll = () => {
        if (dropdownRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = dropdownRef.current;
            if (scrollTop + clientHeight >= scrollHeight - 5) {
                if (hasNextPage && !isFetchingNextPage) {
                    fetchNextPage();
                }
            }
        }
    };

    return (
        <Dropdown
            className="
            flex flex-col
            w-[32rem]
            min-h-56
            max-h-[65vh]
            h-max
            mb-16
            bg-white rounded-lg overflow-hidden"
            arrowIcon={false}
            inline
            label={
                <div>История заявки</div>
            }
        >
            {/*LIST*/}
            <div
                ref={dropdownRef}
                onScroll={handleScroll}
                className="
                    flex flex-col
                    mt-6
                    min-h-56
                    max-h-[50vh]
                    overflow-y-scroll
                    items-start gap-5"
            >
                {data?.pages.map((page, i) => (
                    <React.Fragment key={i}>
                        {page.map((e: ClaimHistory, index) => (
                            <HistoryItem key={index} record={e} />
                        ))}
                    </React.Fragment>
                ))}
            </div>
            {/*Индикатор подгрузки*/}
            {isFetchingNextPage && <LoadingMore />}
        </Dropdown>
    );
}
